// extracted by mini-css-extract-plugin
export default {"container":"MainContainer-module_container__b5_8w"};